import { createSlice } from "@reduxjs/toolkit";
import { getNationality } from "API/CenterDataAPI";
import { getCountry } from "API/CenterDataAPI";
import { getProvince } from "API/CenterDataAPI";
import { getDistrict } from "API/CenterDataAPI";
import {
  getSubDistrict,
  getNameTitle,
  getBankName,
  getLegalEntity,
} from "API/CenterDataAPI";

const initialState = {
  Nationality: [],
  Country: [],
  Province: [],
  District: [],
  SubDistrict: [],
  NameTitle: [],
  Bank: [],
  LegalEntity: [],
};

export const CenterDataSlice = createSlice({
  name: "UserState",
  initialState,
  reducers: {
    updateGetNationality: (state, action) => {
      state.Nationality = action.payload;
    },
    updateGetCountry: (state, action) => {
      state.Country = action.payload;
    },
    updateGetProvince: (state, action) => {
      state.Province = action.payload;
    },
    updateGetDistrict: (state, action) => {
      state.District = action.payload;
    },
    updateGetSubDistrict: (state, action) => {
      state.SubDistrict = action.payload;
    },
    updateGetNameTitle: (state, action) => {
      state.NameTitle = action.payload;
    },
    updateGetBank: (state, action) => {
      state.Bank = action.payload;
    },
    updateGetLegalEntity: (state, action) => {
      state.LegalEntity = action.payload;
    },
  },
});

export const { updateGetNationality } = CenterDataSlice.actions;
export const getNationalitydetail = (value) => async (dispatch) => {
  await getNationality(value).then(async (data) => {
    await dispatch(updateGetNationality(data));
  });
};

export const { updateGetCountry } = CenterDataSlice.actions;
export const getCountrydetail = (value) => async (dispatch) => {
  await getCountry(value).then(async (data) => {
    await dispatch(updateGetCountry(data));
  });
};

export const { updateGetProvince } = CenterDataSlice.actions;
export const getProvincedetail = (value) => async (dispatch) => {
  await getProvince(value).then(async (data) => {
    await dispatch(updateGetProvince(data));
  });
};

export const { updateGetDistrict } = CenterDataSlice.actions;
export const getDistrictdetail = (value) => async (dispatch) => {
  await getDistrict(value).then(async (data) => {
    await dispatch(updateGetDistrict(data));
  });
};

export const { updateGetSubDistrict } = CenterDataSlice.actions;
export const getSubDistrictdetail = (value) => async (dispatch) => {
  await getSubDistrict(value).then(async (data) => {
    await dispatch(updateGetSubDistrict(data));
  });
};

export const { updateGetNameTitle } = CenterDataSlice.actions;
export const getNameTitleDetail = (value) => async (dispatch) => {
  await getNameTitle(value).then(async (data) => {
    await dispatch(updateGetNameTitle(data));
  });
};

export const { updateGetBank } = CenterDataSlice.actions;
export const getBankDetail = (value) => async (dispatch) => {
  await getBankName(value).then(async (data) => {
    await dispatch(updateGetBank(data));
  });
};

export const { updateGetLegalEntity } = CenterDataSlice.actions;
export const getLegalEntityDetail = (value) => async (dispatch) => {
  await getLegalEntity(value).then(async (data) => {
    await dispatch(updateGetLegalEntity(data));
  });
};

export default CenterDataSlice.reducer;
